@if (data) {
  <div class="icon">
    <span class="icon-circle">
      <mat-icon>question_mark</mat-icon>
    </span>
  </div>
  <div class="content">
    <span class="title">{{ "SNACKBAR.INFO" | translate }}</span>
    <p [innerHTML]="data | translate"></p>
  </div>
}
